import { useState, useEffect } from 'react';

function useChangedProps(initialProps, callback) {
  var _a = useState(initialProps),
      setPrevProps = _a[1];

  useEffect(function () {
    setPrevProps(function (p) {
      if (p === initialProps) {
        return initialProps;
      }

      callback(p, initialProps);
      return initialProps;
    });
  }, [initialProps]);
}

export { useChangedProps };